/**
 * fetchWithRetry — thin wrapper around window.fetch that retries once on transient
 * "TypeError: Failed to fetch" errors. This handles a known race with the emergent
 * observability wrapper that occasionally rejects the first fetch on page load.
 *
 * On success  → returns the Response (never throws).
 * On failure  → returns null (caller should use fallback data).
 * Logs a single console.warn (not error) after both attempts fail so real
 * unrecoverable problems still surface without polluting DevTools.
 */
export const fetchWithRetry = async (url, options = {}, { retries = 1, delayMs = 300, label = url } = {}) => {
  let lastErr = null;
  for (let attempt = 0; attempt <= retries; attempt++) {
    try {
      const res = await fetch(url, options);
      return res;
    } catch (err) {
      lastErr = err;
      if (attempt < retries) {
        await new Promise((r) => setTimeout(r, delayMs));
      }
    }
  }
  console.warn(`[fetchWithRetry] gave up on ${label} after ${retries + 1} attempts:`, lastErr?.message || lastErr);
  return null;
};

export default fetchWithRetry;
